/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const TIMER = project.getFeature(feature.getSettingValue('TIMER'));
    if (!TIMER) {
        return blocks;
    }
    const TIMER_VAR = TIMER.getSettingValue('TIMER_NAME');
    const TIMER_NAME = `timer_${TIMER.getSettingValue('TIMER_NAME')}`;

    const links = project.getNodeLinks(feature, 'timer_complete');
    if (links.length > 0) {
        const link = links[0];

        blocks.push({
            location: `${TIMER_NAME}_update`,
            blockType: BlockType.CODE,
            template: `
    if ${TIMER_VAR}=0 then
        #if TIMER_DEBUG_PRINT
        sys.debugprint("timer ${TIMER_NAME} completed at " + lstr(sys.timercountms) + "\\r\\n")
        #endif
        '****${link.getSourceId()}****'
    end if`,
        });
    }

    return blocks;
};
